export default __webpack_public_path__ + "static/media/offloadTime.3a9e56c7.svg";